import { useDashboard } from '@/hooks/useDashboardData'
import { useRealtimeRpm } from '@/hooks/useRealtimeRpm'
import { useAuthStore } from '@/stores/authStore'
import { useTranslation } from 'react-i18next'
import { StatsCards } from '@/components/dashboard/StatsCards'
import { ChartsPanel } from '@/components/dashboard/ChartsPanel'
import { RecentRecordsPanel } from '@/components/dashboard/RecentRecordsPanel'
import {
  DashboardFilterBar,
  formatDashboardFilterSubtitle,
} from '@/components/dashboard/DashboardFilterBar'
import PageHeader from '@/components/Layout/PageHeader'

export default function Dashboard() {
  const { t } = useTranslation()
  const {
    stats,
    trendData,
    filter,
    setQuickPreset,
    setFilterRange,
    setTokenId,
    quotaLoading,
    activeChartTab,
    setActiveChartTab,
  } = useDashboard()
  const { rpm, isLoading: rpmLoading, isError: rpmError } = useRealtimeRpm({
    tokenId: filter.tokenId,
  })

  const user = useAuthStore((state) => state.user)

  const title = user?.username
    ? t('tt.dashboard.welcomeUser', { username: user.username })
    : t('tt.dashboard.title')

  const rangeLabel = formatDashboardFilterSubtitle(filter, t)

  return (
    <div className="space-y-4">
      <PageHeader title={title} />

      <StatsCards
        balance={user?.quota || 0}
        todayRequests={stats?.todayCalls ?? 0}
        todayQuota={stats?.todayQuota ?? 0}
        todayLoading={quotaLoading}
        realtimeRpm={rpm}
        realtimeRpmLoading={rpmLoading}
        realtimeRpmError={rpmError}
      />

      <DashboardFilterBar
        value={filter}
        onSelectPreset={setQuickPreset}
        onRangeChange={setFilterRange}
        onTokenChange={setTokenId}
      />

      <ChartsPanel
        data={trendData || []}
        rangeLabel={rangeLabel}
        activeTab={activeChartTab}
        onTabChange={setActiveChartTab}
        isAdmin={(user?.role ?? 0) >= 10}
      />

      <RecentRecordsPanel />
    </div>
  )
}
